import TreasuryMain from "@/views/treasury/views/TreasuryMain.vue"
import TreasuryAttendanceRoute from "@/views/treasury/views/treasury-attendance/router/treasury-attendance.route.js"
// import TreasuryDiscounts from "@/views/treasury/views/treasury-discounts/router/treasury-discounts.route.js"
import TransactionsRouter from "@/views/treasury/views/transactions/transactions.route.js";
import BankAccountsRouter from "@/views/treasury/views/bank-accounts/bank-accounts.route.js";

const routes = [
    {
        path: "/treasury/",
        name: "treasury",
        redirect: { name: "treasury-attendance" },
        meta: { module: 5 },
        component: TreasuryMain,
        children: [
            ...TreasuryAttendanceRoute,
            // ...TreasuryDiscounts,
            ...TransactionsRouter,
            ...BankAccountsRouter
        ]
    },

];

export default routes;
